module.exports = __webpack_public_path__ + "static/img/beian-icon.58f55c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beian-icon.png
// module id = oj0V
// module chunks = 1